export enum ProfileTab {
  Overview = 'Overview',
  LeaveBalance = 'Leave Balance',
  Attendance = 'Attendance',
  Assets = 'Assets',
  Education = 'Education',
  Experience = 'Experience',
  InfoDocuments = 'Legal Info & Official Documents',
}
